import { render, staticRenderFns } from "./BrowserTestTool.vue?vue&type=template&id=fc080470&scoped=true"
import script from "./BrowserTestTool.vue?vue&type=script&lang=js"
export * from "./BrowserTestTool.vue?vue&type=script&lang=js"
import style0 from "./BrowserTestTool.vue?vue&type=style&index=0&id=fc080470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc080470",
  null
  
)

export default component.exports